const keys = [
    {
        key: 'allPages',
        label: 'All Pages',
        type: 'bar',
    },
    {
        key: 'newPages',
        label: 'New Pages',
        type: 'bar',
    },
];

export default keys;
